import { create } from 'zustand'
import { createStorage } from './storage'
import { devtools, persist } from 'zustand/middleware'

export interface BefehlMarkedAsDoneEntry {
  markedAsDone: Record<string, boolean>
  setMarkedAsDone: (id: string, markAsDone: boolean) => void
  isDone: (id: string) => boolean
}

export const useBefehlMarkedAsDoneStore = create<BefehlMarkedAsDoneEntry>()(
  devtools(
    persist(
      (set, get) => ({
        markedAsDone: {},

        setMarkedAsDone: (id: string, markAsDone: boolean) => {
          set(
            (state) => ({
              markedAsDone: {
                ...state.markedAsDone,
                [id]: markAsDone
              }
            }),
            false,
            'setMarkAsDone'
          )
        },

        isDone: (id: string) => {
          return get().markedAsDone[id] ?? false
        }
      }),
      {
        name: 'marked-as-done-storage',
        storage: createStorage(),
        version: 0
      }
    )
  )
)
